import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const categoriesApi = createApi({
  reducerPath: "categories",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "categories",
  }),
  endpoints: (builder) => ({
    getAllCategories: builder.query({
      query: (query) => ({
        url: `/tree${query ? query : ""}`,
        method: "GET",
      }),
    }),
    getPriorityCategory: builder.query({
      query: () => ({
        url: "?home_priority=true",
        method: "GET",
      }),
    }),
  }),
});

export const { useGetAllCategoriesQuery, useGetPriorityCategoryQuery } =
  categoriesApi;
